__turbopack_context__.v({
  "className": "roboto_f711bd84-module__pN5Wuq__className",
  "variable": "roboto_f711bd84-module__pN5Wuq__variable",
});
